import type { FaireProductEntity } from "../../entity_types/product";

export const p_kdnrt8sv5q: FaireProductEntity = {
  token: "p_kdnrt8sv5q",
  type: "product",
  name: "LM-CT-1001 Puffer Jacket - White",
  brandToken: "b_h6l667zq",
  brandName: "Girlie Girl Originals",
  imageUrl: "https://cdn.faire.com/fastly/da431e0613ff90f25c2c2184cef3dc4d9f7ceb9d06d3625628fe5c28b70b69fb.jpeg",
  galleryImageUrls: [],
  priceDollars: 44.5,
  description: "This lightweight puffer jacket from Girlie Girl Originals offers cozy warmth and stylish design for casual wear. It features a clean white finish and a silhouette that adapts to casual or polished looks. A reliable outerwear choice from a brand known for bold, fun apparel and southern flair.",
  tags: [],
  msrpDollars: 89,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:01:18.672Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
